import React from 'react'
import { useTranslation } from 'react-i18next'
import { Separator, LayoutBand, Image, H3, Paragraph } from '@fs/zion-ui'
import { cdnRoot } from '../../services/services'

export default function PrepareForTemple() {
  const [t] = useTranslation()
  return (
    <LayoutBand maxWidth="xs">
      <Separator />
      <Image
        alt={t('temple.picture.alt.templeprep', 'Spirirtual youth temple preparation')}
        src={`${cdnRoot}/connect/informational/youth_temple_prep_spiritual.png`}
      />
      <Separator />

      <H3>{t('informational.temple.prepare.heading', 'Preparing Your Child for Temple Baptisms and Confirmations')}</H3>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.intro',
          "Young women and ordained young men can receive temple recommends beginning January of the year they turn 12. If your child turns 12 this year, now is a great time to help him or her prepare to go to the temple and participate in temple baptisms! Below is the first in a five-part series of articles and activities to help you prepare together. And even if you live far from a temple or your child's first visit isn't happening soon, blessings will still come as your child prepares for and receives a recommend and engages in family history."
        )}
      </Paragraph>
      <Separator />
    </LayoutBand>
  )
}
